import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState, useMemo } from 'react';

export interface UseResizeBanner {
	setBannerElement: Dispatch<SetStateAction<HTMLDivElement | null>>;
	bannerHeight: number;
	setBannerHeight: Dispatch<SetStateAction<number>>;
}

export const useResizeBanner = (isSSR: boolean): UseResizeBanner => {
	const [bannerHeight, setBannerHeight] = useState(0);
	const [bannerElement, setBannerElement] = useState<HTMLDivElement | null>(null);

	const resizeObserver = useMemo(() => {
		if (!isSSR) {
			return new ResizeObserver((entries: Array<ResizeObserverEntry>) => {
				for (const entry of entries) {
					setBannerHeight(entry.borderBoxSize[0].blockSize);
				}
			});
		}
	}, [isSSR]);

	useEffect(() => {
		if (bannerElement && resizeObserver) {
			resizeObserver.observe(bannerElement);
			return () => resizeObserver.unobserve(bannerElement);
		} else {
			setBannerHeight(0);
		}
	}, [bannerElement, resizeObserver]);

	return {
		setBannerElement,
		bannerHeight,
		setBannerHeight,
	};
};
